import React from "react";

import ComputerImage from "../Assets/Computer.png";
import "./Home.css";
import { Fotter } from "../componets/Fotter";



const Home = () => {
  const handleDownload = () => {
    // Ruta al archivo PDF en la carpeta pública
    const pdfUrl =
      process.env.PUBLIC_URL + "/Susana_Garcia_Frontend_React_Developer.pdf";

    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "CV.pdf";
    link.click();
  };

  return (
    <div >
 
    <div className="home">
      <div className="home1">
        <h1 className="home-hi">Hello I´m</h1>
        <h1 className="home-hi">Susana García</h1>
        <p className="home-p">
          I am a Frontend developer with a focus on UI/UX, dedicated to crafting
          unique user experiences through the creation of web applications that
          fulfill client needs. My approach is grounded in meticulous planning,
          thorough research, design, and software programming to deliver
          solutions that bring added value to clients.
          <br />
          With proficiency in technologies like JavaScript and React, I possess
          the ability to translate ideas and requirements into appealing and
          functional interfaces. My primary goal is to ensure that every
          interaction with the application is intuitive and enjoyable, providing
          an exceptional user experience.
        </p>
      </div>

      <div className="home2">
        <img src={ComputerImage} alt="Computadora" className="img-home" />
        <button className="CV-download" onClick={handleDownload}>
         Download CV
        </button>
      </div>
    </div>
    <Fotter/>

    </div>
  );
};

export default Home;
